import { render, staticRenderFns } from "./CancelIframe.vue?vue&type=template&id=90512c12&"
import script from "./CancelIframe.vue?vue&type=script&lang=ts&"
export * from "./CancelIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports